// extracted by mini-css-extract-plugin
export var infoItem = "_r2-2";
export var title = "_r2-0";
export var value = "_r2-1";